export default "__VITE_ASSET__BKsDw5Kg__"